import React, {useState, useEffect} from 'react';
import { useTheme } from '@mui/material/styles';
import { 
  XAxis, 
  YAxis, 
  Label, 
  ResponsiveContainer,
  CartesianGrid,
  LineChart,
  Legend,
  Line,
   } from 'recharts';
import InfoIcon from '@mui/icons-material/Info';
import {
  IconButton,
  Grid,
  Tooltip
} from '@mui/material';

import Title from '../../../../components/Title';
import socket from '../../../../services/socket';
import {Tooltip as TooltipRecharts} from 'recharts';


export default function Revenue(props) {
  const store_id = props.store_id
  const [sales,setSales] = useState([]);
  const theme = useTheme();
  useEffect( () => {   
    function askSales(){
      socket.emit('/vezo/StoreInfo/askSales',{ 
                      'store_id': store_id}
                    ,(data)=>{console.log(data);})
    }
    async function loadSales(){
        askSales()
        socket.on('/vezo/StoreInfo/updateSales/'+store_id,()=>{
          // When the server sends a updatePaperInfo, it asks for newer intel
          askSales();
        })
        socket.on('/vezo/StoreInfo/Sales/'+store_id,(data)=>{
          setSales(data);
        });
        return () => socket.disconnect();
    }
    loadSales();    
  },[store_id]);

  return (
    <React.Fragment>
      <Grid container spacing={3}  justifyContent={"center"} direction="row">
          <Grid item xs={12} md={2} lg={1}>
            <Tooltip title="Faturamento, nesta loja, hoje!">
              <IconButton aria-label="Selecionar" size="large">
                <InfoIcon />
              </IconButton>
            </Tooltip>
          </Grid>
          <Grid item xs={12} md={10} lg={11}>
            <Title>Faturamento</Title>
          </Grid>
        </Grid>
        <ResponsiveContainer>
            <LineChart
            data={sales}
            margin={{
                top: 16,
                right: 16,
                bottom: 0,
                left: 24, 
            }}
            > 
            <CartesianGrid strokeDasharray="1 3" />
            <TooltipRecharts isAnimationActive={false}/>
            <Legend />
            <XAxis dataKey="hour" stroke={theme.palette.text.secondary} />
            <YAxis stroke={theme.palette.text.secondary}>
                <Label
                angle={270}
                position="left"
                style={{ textAnchor: 'middle', fill: theme.palette.text.primary }}
                >
                Faturamento
                </Label>
            </YAxis>
            <Line type="monotone" name ="Faturamento" dataKey="sales" stroke="#8884d8" />
            </LineChart>
        </ResponsiveContainer>
    </React.Fragment>
  );
}